import {FormControl, FormLabel, Grid, Typography} from '@material-ui/core'
import React, {useContext} from 'react'
import {useTranslation} from 'react-i18next'
import ControlContainer from '../components/ControlContainer'
import {OrderContext} from '../OrderContext'
import {CancelButton, NextButton, PreviousButton} from '../StepperButtons'
import AddressCard from './AddressCard'
import {DatePicker} from "@material-ui/pickers";
import {addBusinessDays, addDays, isWeekend} from "date-fns";

const ShipToSelector = () => {
    const {shipTo, setShipTo, addresses, dropOffDate, setDropOffDate, pickupDate} = useContext(OrderContext)
    const {t} = useTranslation()

    return (
        <>
            <Typography variant='h4'>{t('select_shipping_address')}:</Typography>
            <br/>
            <br/>
            <br/>

            <Grid container spacing={3}>
                {addresses?.map((a, i) =>
                    <Grid item xs={12} sm={6} md={4} key={i}>
                        <AddressCard address={a} active={shipTo === a.customer}
                                     selectText={t('select_this_shipping_address')} onSelect={a => setShipTo(a)}/>
                    </Grid>
                )}
            </Grid>

            <br/>
            <br/>
            <br/>

            <FormControl>
                <FormLabel>{t('requested_shipping_date')}</FormLabel>
                <DatePicker
                    disableToolbar
                    autoOk
                    format="P"
                    minDate={addBusinessDays(pickupDate, 1)}
                    maxDate={addDays(pickupDate, 30)}
                    shouldDisableDate={d => isWeekend(d as Date)}
                    variant="inline"
                    margin="normal"
                    value={dropOffDate}
                    onChange={(d) => setDropOffDate(d)}
                    onBlur={() => {
                        if (!dropOffDate) setDropOffDate(addBusinessDays(new Date(), 1))
                    }}
                />
                <Typography variant='subtitle1'>{t('date_disclaimer')}</Typography>
            </FormControl>

            <ControlContainer>
                <NextButton disabled={!shipTo}/>
                <PreviousButton/>
                <CancelButton/>
            </ControlContainer>
        </>
    )
}

export default ShipToSelector
